/**
 * guobgf 2021-03-14
 * 统一注册方法,ncc mobile平台需要用到的方法
 * 1. 根据不同的平台注册不同的方法，使用时统一调用
 * 2. 注册完各平台的方法之后，再注册通用方法，主要用于报错处理，
 *    比如有的平台没有注册某个用到的方法，通用方法又不能处理的，会报错，提示添加
 *    （主要给客开用的，帮助客开适配不同平台）
 */

import {platform, isUcg} from './core/getEnv';
import default_acts from './platform/defalut';

class NccMb {
    constructor() {
        this.platform = platform;
        this.version = '0.0.1';
        this.isUcg = isUcg;
        this.apilist = [];
    }

    /**
     * 扩展 nccmb 的 api
     * @param {String} api 扩展方法名
     * @param {String} platform 扩展平台: all|ios|android|h5;
     * @param {String} symbolPath 扩展方法绑定字段，例如 api = 'm1', symbolPath = 'xx' 则注册完后调用方式为 mtl.xx.m1。
     * @param {Function} fn 扩展方法绑定字段
     * @param isDefault 是否默认方法
     */
    register({api, platform = 'all', symbolPath = null, fn}, isDefault) {
        if ((platform !== 'all' && platform !== this.platform)) {
            return
        }

        if (isDefault) {
            if (this.apilist[api]) return;
            if (!fn) {
                if (this.platform === 'h5') {
                    //h5一般没有native方法，就不报错了
                    fn = () => {
                    };
                } else {
                    fn = () => console.warn(`
                        ${this.platform}${this.isUcg ? '_ucg' : ''} 平台没有注册 ${api} 方法，
                        可能会导致一些方法不可用，如果您确实需要用到该方法，
                        请到'src/hrzz/public/ncc-moible/platform/${this.platform}${this.isUcg ? '/ucg' : ''}'下添加
                    `)
                }
            }
        }

        if (this.apilist[api]) {
            throw new Error(`api "${api}" already exists!`)
        }
        this.apilist[api] = true
        /*if (this.platform == 'ios' || this.platform == 'android') {
            // ios 和 android 端需要对参数进行一层处理
            let originFn = fn;
            let nativeFn = function (args) {
                originFn(nativeTransformArgs(args))
            }
            fn = nativeFn
        }*/
        if (symbolPath) {
            prepareNamespace(symbolPath, nccmb)
            let obj = {}
            let cur = obj;
            let parts = symbolPath.split('.');
            for (let part of parts) {
                cur = cur[part] = {}
            }
            cur[api] = fn
            merge(nccmb, obj)
        } else {
            nccmb[api] = fn
        }
    }
}

function prepareNamespace(symbolPath, context) {
    if (!symbolPath) {
        return context;
    }
    let parts = symbolPath.split('.');
    let cur = context;
    for (let i = 0, part; part = parts[i]; ++i) {
        cur = cur[part] = cur[part] || {};
    }
    return cur;
}

const merge = (target, source) => {
    for (let key of Object.keys(source)) {
        if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]))
    }
    Object.assign(target || {}, source)
    return target
}

let nccmb = new NccMb();
(function () {
    let apilist = []
    switch (platform) {
        case 'wx':
        case 'dd':
        case 'upesn':
            //apilist = isUcg ? upesn_ucg_acts : upesn_acts;
            apilist = require("./platform/upesn/ucg").default;
            break
        case 'h5':
            //if(!isUcg){
            sessionStorage.setItem('mobile-web-page', 'true');
            sessionStorage.setItem('showNav', 'true');
            //}
            //apilist = isUcg ? h5_ucg_acts : h5_acts;
            apilist = require("./platform/h5").default;
            break
        case 'h5_ucg':
            sessionStorage.setItem('mobile-web-page', 'true');
            sessionStorage.setItem('showNav', 'true');
            // if (isUcg) {
            //     apilist = require("./platform/h5/ucg").default;
            // } else {
            //     apilist = require("./platform/h5").default;
            // }
            apilist = require("./platform/h5").default;
    }
    for (let api of apilist) {
        nccmb.register(api)
    }
    for (let defApi of default_acts) {
        nccmb.register(defApi, true)
    }
})();

export default nccmb;